<div class="skeleton-section">
  <ng-container *ngFor="let item of loopCounter()">
    <span class="skeleton-box" [style.width]="width" [style.height]="height"></span>
  </ng-container>
</div>